/* ============================================================
   Filtrage temps réel pour la grille classique (#product-grid)
   - Écoute 'price-range:change' (émis en continu pendant le drag, debounce 100ms)
   - Cache/montre les .grid__item via la classe .is-filtered-out
   - Filtre aussi par disponibilité (radios data-availability-radio)
   - Se ré-applique après chaque rechargement AJAX du ProductGridContainer
   ============================================================ */

(function () {
  if (typeof window === 'undefined') return;

  document.addEventListener('DOMContentLoaded', initGridFilter);

  function initGridFilter() {
    const sidebar = document.querySelector('.collection-sidebar');
    if (!sidebar) return;

    // En mode "Par collection", c'est collection-grouped-view.js qui gère le filtrage.
    // On ne s'active QUE si on est en mode grille (pas de [data-grouped-view] dans la page).
    if (document.querySelector('[data-grouped-view]')) return;

    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const state = {
      priceMin: 0,
      priceMax: Number.POSITIVE_INFINITY,
      availabilityValue: null,
      // Drapeaux pour distinguer "filtre actif" de "valeurs par défaut" :
      priceRangeMin: 0,
      priceRangeMax: Number.POSITIVE_INFINITY,
    };

    initStateFromInputs();
    setupAvailabilityRadios();
    applyFilters();

    sidebar.addEventListener('price-range:change', (e) => {
      state.priceMin = e.detail.min;
      state.priceMax = e.detail.max;
      applyFilters();
    });

    sidebar.addEventListener('change', (e) => {
      const target = e.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.dataset.availabilityRadio === undefined) return;
      refreshAvailabilityState();
      applyFilters();
    });

    // Ré-applique le filtre après chaque rerender AJAX du ProductGridContainer.
    // facets.js remplace innerHTML → on observe les ajouts de noeuds enfants.
    const observer = new MutationObserver(() => {
      // Re-binder les radios dispo (la sidebar n'est pas re-rendue mais on reste safe)
      setupAvailabilityRadios();
      applyFilters();
    });
    observer.observe(gridContainer, { childList: true, subtree: true });

    function initStateFromInputs() {
      const priceSlider = sidebar.querySelector('price-range-slider');
      if (priceSlider) {
        const rangeMin = parseFloat(priceSlider.dataset.rangeMin || '0');
        const rangeMax = parseFloat(priceSlider.dataset.rangeMax || '0');
        const currentMin = parseFloat(priceSlider.dataset.currentMin || '0');
        const currentMax = parseFloat(priceSlider.dataset.currentMax || rangeMax);
        state.priceRangeMin = isNaN(rangeMin) ? 0 : rangeMin;
        state.priceRangeMax = rangeMax > 0 ? rangeMax : Number.POSITIVE_INFINITY;
        state.priceMin = isNaN(currentMin) ? state.priceRangeMin : currentMin;
        state.priceMax = currentMax > 0 ? currentMax : state.priceRangeMax;
      }
      refreshAvailabilityState();
    }

    function refreshAvailabilityState() {
      const radios = sidebar.querySelectorAll('input[data-availability-radio]');
      let active = null;
      radios.forEach((r) => { if (r.checked) active = r.value; });
      state.availabilityValue = active;
      radios.forEach((r) => {
        const label = r.closest('[data-availability-label]');
        if (label) label.classList.toggle('active', r.checked);
      });
    }

    /** Permet de cliquer une 2e fois sur un radio coché pour le désélectionner */
    function setupAvailabilityRadios() {
      const radios = sidebar.querySelectorAll('input[data-availability-radio]');
      radios.forEach((radio) => {
        if (radio._gridFilterBound) return;
        radio._gridFilterBound = true;
        radio.addEventListener('mousedown', () => {
          radio._wasChecked = radio.checked;
        });
        radio.addEventListener('click', () => {
          if (radio._wasChecked) {
            radio.checked = false;
            radio._wasChecked = false;
            refreshAvailabilityState();
            applyFilters();
          }
        });
      });
    }

    function applyFilters() {
      const items = gridContainer.querySelectorAll('#product-grid .grid__item[data-product-price]');
      items.forEach((item) => {
        const price = parseFloat(item.dataset.productPrice || '0');
        const available = item.dataset.productAvailable === 'true';

        let visible = true;

        if (price < state.priceMin || price > state.priceMax) {
          visible = false;
        }

        if (visible && state.availabilityValue !== null) {
          if (state.availabilityValue === '1' && !available) visible = false;
          if (state.availabilityValue === '0' && available) visible = false;
        }

        item.classList.toggle('is-filtered-out', !visible);
      });
    }
  }
})();
